import { useEffect, useState } from 'react';
import { useCalibration } from '../../../context/calibrationContext';
import { usePostMessage, useReceiveMessage } from '../../../context/messageContext';
import { CameraCalibrationView } from '../../session/calibration/ClinicianCalibrationViews';
import { useCalibrationSync } from '../../session/calibration/sync';

// C4.1 Camera Calibration with the IBIS tool. `initialiseToolDetections` starts the patient's tool
// tracker; the patient answers with `perceivedFocalLength` (0 = failed).
const CameraCalibration = ({ setStep }) => {
  const [calibrationStatus, setCalibrationStatus] = useState(0);
  const { updateCalibrationData, calibrationData } = useCalibration();
  const messageFromPatient = useReceiveMessage();
  const postMessage = usePostMessage();
  const { patchCalibration } = useCalibrationSync();

  const calibrateCamera = () => {
    setCalibrationStatus(1);
    updateCalibrationData({ cameraCalibrated: false });
    postMessage({ type: 'initialiseToolDetections', content: {} });
  };

  useEffect(() => {
    if (messageFromPatient?.type === 'perceivedFocalLength') {
      let cameraCalibrated = true;
      if (!messageFromPatient.content.perceivedFocalLength) {
        setCalibrationStatus(0);
        cameraCalibrated = false;
      }
      updateCalibrationData({ perceivedFocalLength: messageFromPatient.content.perceivedFocalLength, cameraCalibrated: cameraCalibrated });
      patchCalibration({ camera_calibrated: cameraCalibrated });
    }
  }, [messageFromPatient, updateCalibrationData, patchCalibration]);

  useEffect(() => {
    if (calibrationData.cameraCalibrated) setCalibrationStatus(2);
  }, [calibrationData.cameraCalibrated]);

  return (
    <CameraCalibrationView
      status={calibrationStatus}
      onBegin={calibrateCamera}
      onBack={() => {
        postMessage({ type: 'holding' });
        setStep('camera-calibration-selection');
      }}
      onNext={() => {
        postMessage({ type: 'calibration-selection' });
        setStep('calibration-selection');
      }}
    />
  );
};

export default CameraCalibration;
